import { styled } from '@ublend-npm/aulaui-core';

export const AulaEditorWrapper = styled('div')(({ readOnly }) => ({
  opacity: readOnly ? 0.5 : 1,
}));
